module.exports = __webpack_public_path__ + "img/xiaochengxu.a078bef5.jpg";